import axios from 'axios'
import { URLS } from '../../util/urls'
import debugHelper from '../../util/debug'
import tools from '../../util/tools'

const state = {
  /*
  app-cs-create-non-pump-order-limit-time // 施工端允许创建非泵订单的最早时间：	0今天 1明天 2后天 以此类推
  app-cs-create-pump-order-limit-time"     // 施工端允许创建泵送订单的最早时间：	0今天 1明天 2后天 以此类推
  app-driver-show-waybill-state // 司机端新货单开始显示的状态： 创建、开始生产、首盘生产完成、开始运送
  */

  nonPumpOrderLimitTime: 0,
  pumpOrderLimitTime: 0,
  driverShowWaybillState: '开始运送'
}

const getters = {
  getParamOfNonPumpOrderLimitTime: state => {
    return state.nonPumpOrderLimitTime
  },
  getParamOfPumpOrderLimitTime: state => {
    return state.pumpOrderLimitTime
  },
  getDriverShowWaybillState: state => {
    return state.driverShowWaybillState
  },
}

const actions = {
  fetchParamOfNonPumpOrderLimitTime: ({ commit }, params) => {
    console.log('调试代码')
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.CONFIG_URL + '/app-cs-create-non-pump-order-limit-time',
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('setParam', {
            value: resp.data.data,
          })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'config:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  fetchParamOfPumpOrderLimitTime: ({ commit }, params) => {
    console.log('调试代码')
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.CONFIG_URL + '/app-cs-create-pump-order-limit-time',
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('setParam', {
            value: resp.data.data,
          })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'config:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  fetchParamOfDriverShowWaybillState: ({ commit }, params) => {
    console.log('调试代码')
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.CONFIG_URL + '/app-driver-show-waybill-state',
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('setParam', {
            value: resp.data.data,
          })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'config:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
  fetchParam: ({ commit }, params) => {
    console.log('调试代码')
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.CONFIG_URL + params.paramName,
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('setParam', {
            value: resp.data.data,
          })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'config:'
          tools.showTips(params.vm, err)
          reject()
          return
        })
    })
  },
}

const mutations = {
  setParam: (state, payload) => {
    switch (payload.value.name) {
      case 'app-cs-create-non-pump-order-limit-time':
        state.nonPumpOrderLimitTime = payload.value.value
        break

      case 'app-cs-create-pump-order-limit-time':
        state.pumpOrderLimitTime = payload.value.value
        break

      case 'app-driver-show-waybill-state':
        state.driverShowWaybillState = payload.value.value
        break

    }

  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
